export const environment = {
  production: true,
  apiBaseUrl: 'https://api.rtila.ai',
  turnstileSiteKey: '0x4AAAAAADw6-t5qHXeu6fvK'
};
